import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-570f4471"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Header = _resolveComponent("Header");
  const _component_el_header = _resolveComponent("el-header");
  const _component_LeftMenu = _resolveComponent("LeftMenu");
  const _component_el_aside = _resolveComponent("el-aside");
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_main = _resolveComponent("el-main");
  const _component_Footer = _resolveComponent("Footer");
  const _component_el_footer = _resolveComponent("el-footer");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
    class: "main-container"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_header, null, {
      default: _withCtx(() => [_createVNode(_component_Header)]),
      _: 1
    }), _createVNode(_component_el_container, {
      class: "sub-container"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_aside, {
        width: "200px",
        style: {}
      }, {
        default: _withCtx(() => [_createVNode(_component_LeftMenu)]),
        _: 1
      }), _createVNode(_component_el_container, null, {
        default: _withCtx(() => [_createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createVNode(_component_router_view)]),
          _: 1
        }), _createVNode(_component_el_footer, {
          height: "60px"
        }, {
          default: _withCtx(() => [_createVNode(_component_Footer)]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })]);
}